<div class="col-sm-12 ficheTransporteur" *ngIf="!isEmpty">
    <div *ngIf="!isEmpty" class="header fiche">
        <div class="col-sm-6 fiche-client" style="padding: 0 15px;white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;">
            Tampon/signature transporteur
        </div>
        <div class="col-sm-6 text-right" style="padding-right: 0;">
            <button class="btn-header uppercase" (click)="annuler()" id="close2">
                Fermer </button>
            <button class="btn-header uppercase actionPricipal" id="valide2" (click)="save()">
                Valider </button>
        </div>
    </div>
    <mat-divider *ngIf="!isEmpty"></mat-divider>
    <div style="padding-top: 10px;" class="contente">
        <div class="group1 info-client">
            <div class="col-sm-8" style="padding: 10px 15px;">
                <label>
                    Choix d'un tampon/signature transporteur
                </label>
            </div>

            <!--
        <div class="col-sm-4 text-right" style="padding-right: 0;">
            <button class="btn-header uppercase" (click)="annuler()" id="close2" style="margin-right: 5px">
                Annuler </button>
            <button class="btn-header uppercase actionPricipal" id="valide2" (click)="save()">
                Valider </button>
        </div>
        -->

            <div class="form-group col-sm-12" style="padding: 0;">
                <label class="col-sm-3 champ" for="input-file-id" style="padding: 0;"> Fichier (Max. 2Mo) : </label>
                <input class="hide" id="input-file-id" (change)="getNameFile($event, fileToAdd)" type="file"  accept="{{ common.extFichierImgEtTexte }}"  />
                <div class="input-group col-sm-9 champ">
                    <input type="text" class="form-control" [(ngModel)]="fileToAdd.nomFichier" readonly>
                    <label class="input-group-addon" for="input-file-id"><i class="fa fa-upload"></i> Parcourir </label>
                </div>
            </div>

            <div class="form-group col-sm-12" style="padding: 0;" *ngIf="cheminLogo">
                <label class="col-sm-3 champ" for="input-file-id" style="padding: 0;">&nbsp;</label>
                <div class="input-group col-sm-9 champ">
                    <img src="{{ cheminLogo }}" alt="{{ cheminLogo }}"
                        style="max-width: 100%; width: auto; max-height: 100px;" />
                    <!--
                <button class="btn-header uppercase" id="supprimer" (click)="deleteLogo()" style="margin-left: 10px">
                    Supprimer </button>                  
              -->
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div class="col-sm-12" style="padding: 0;font-size: 14px;font-family: 'Roboto-Black';">
      <span [innerHTML]="error"></span>
    </div>
    <div class="col-sm-12 text-right" style="margin-top: 15px; padding: 0;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();">
        Fermer </button>
    </div>
  </div>
</ng-template>